import type { Character, CharacterInput } from "@/features/characters/types";

export function createCharacterFromInput(input: CharacterInput): Character {
  const now = new Date().toISOString();

  return {
    ...input,
    id: crypto.randomUUID(),
    createdAt: now,
    updatedAt: now,
  };
}

export function updateCharacterFromInput(
  existing: Character,
  input: CharacterInput,
): Character {
  return {
    ...existing,
    ...input,
    updatedAt: new Date().toISOString(),
  };
}

export function calculatePowerScore(character: Character) {
  const attributes = Object.values(character.attributes).reduce(
    (total, current) => total + current,
    0,
  );

  return attributes + character.level * 2;
}

export function getCharacterTitle(character: Character) {
  return character.epithet
    ? `${character.name}, ${character.epithet}`
    : character.name;
}

export function getCharacterSubtitle(character: Character) {
  return `${character.className} ${character.level} • ${character.ancestry} • ${character.origin}`;
}

export function sortCharacters(characters: Character[]) {
  return [...characters].sort(
    (left, right) =>
      new Date(right.updatedAt).getTime() - new Date(left.updatedAt).getTime(),
  );
}
